import { Component, inject } from '@angular/core';
import { LayoutService } from '@app/layout/services/layout.service';
import { TokenRefreshService } from '@outlaw/core';

@Component({
  selector: 'app-root',
  template: `
    @if ($isRefreshing()) {
      <ol-line-loader></ol-line-loader>
    }
    <div (click)="closeLayoutPanels()">
      <router-outlet />
    </div>
  `,
  standalone: false,
})
export class AppComponent {
  $isRefreshing = inject(TokenRefreshService).isRefreshing;
  title = 'community';

  private layoutService = inject(LayoutService);

  closeLayoutPanels(): void {
    this.layoutService.closeAll();
  }
}
